import { render, staticRenderFns } from "./gicc_list.vue?vue&type=template&id=33733a32&scoped=true&"
import script from "./gicc_list.vue?vue&type=script&lang=js&"
export * from "./gicc_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33733a32",
  null
  
)

export default component.exports